import { _single } from "../../../core/services/dataBean/EntityCatalog"
import { MASK_MYEDITOR, MASK_TEXT } from "./BasicTable";

interface Props{   
    value:any;
    mask?:number;
}
export const SpanRender = ({value,mask=MASK_TEXT}:Props) => {
    return (        
        <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(value, mask) }} />        
    )
}